import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { RippleButton } from "@/components/Cinematic";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Admin — Pravidhi Jain";
    if (user) navigate("/admin/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const field = "w-full rounded-sm border border-[#81754B]/40 bg-[#F7F1E1] px-4 py-3 text-[#3F3F2C] focus:border-[#66371B] focus:outline-none";

  return (
    <div className="grain min-h-screen bg-[#3F3F2C] grid place-items-center px-6">
      <div className="w-full max-w-md rounded-sm bg-[#F7F1E1] p-10 shadow-2xl">
        <p className="font-serif text-3xl text-[#3F3F2C]">seedesign<span className="text-[#66371B]"> / admin</span></p>
        <p className="text-sm text-[#81754B] mt-1 mb-8">Admin access</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div><label className="block text-sm uppercase tracking-[0.12em] text-[#3F3F2C] mb-2">Email</label>
            <input className={field} type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" /></div>
          <div><label className="block text-sm uppercase tracking-[0.12em] text-[#3F3F2C] mb-2">Password</label>
            <input className={field} type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" /></div>
          <RippleButton type="submit" testId="admin-login-submit" disabled={loading}
            className="w-full rounded-full bg-[#66371B] px-6 py-3 text-[#F7F1E1] hover:bg-[#3F3F2C] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </RippleButton>
        </form>
      </div>
    </div>
  );
}
